import { onScroll } from 'animejs';

class ColorTransition {
	constructor() {
		let cache = {};
		let initFunc = () => {
			initCache();
			registerEvents();
		};

		let initCache = () => {
			cache.colorModules = document.querySelectorAll(
				".module-03-podcast, .module-14-blog-articles"
			);
            cache.blogTemplate = document.querySelector(".template-blog");
            cache.singleNews = document.querySelector("article.single-news");
            cache.header = document.querySelector(".site-header");
		};

		let registerEvents = () => {
			if (cache.blogTemplate || cache.singleNews) {
				document.body.classList.add("color-switch");
				cache.header.classList.add("color-switch-header");
				return;
			}

			cache.colorModules.forEach((module) => {
				onScroll({
					target: module,
					axis: 'y', 
					enter: 'bottom-=10% top+=10%', 
					leave: 'top+=10% bottom-=10%', 
					repeat: true, 
					onEnter: () => {
						document.body.classList.add("color-switch");
						if (cache.header) {
							cache.header.classList.add("color-switch-header");
						}
					},
					onLeave: () => {
						document.body.classList.remove("color-switch");
						if (cache.header) {
							cache.header.classList.remove("color-switch-header");
						}
					},
				});
			});
		};

		initFunc();
	}
}

export { ColorTransition };
